export default {
	role: {
		contact: 'Kapcsolattartó',
		user: 'Felhasználó',
		admin: 'Adminisztrátor',
		guest: 'Vendég',
	},
	status: {
		pending: 'Aktiválás alatt',
		all: 'Összes',
		active: 'Aktív',
		inactive: 'Inaktív',
		deleted: 'Törölt',
	},
	school: {
		primary: 'Általános',
		vocational: 'Szakmunkás / technikum',
		graduation: 'Érettségi',
		nqr: 'OKJ',
		college: 'Főiskola / Bsc.',
		university: 'Egyetem / Msc.',
		other: 'Egyéb',
	},
	invite_code: {
		used: 'Felhasznált',
		unused: 'Felhasználatlan',
	},
	sex: {
		man: 'Férfi',
		woman: 'Nő',
		other: 'Egyéb',
		none: 'Nem adom meg',
	},
};
